import {
    request,
} from '../request.js'

// 所有
export function reqConsumeList(data) {
    return request({
        url: '/web/back/sys/consume/consumeList',
        method: 'post',
        data
    })
}
// 
export function reqGetByUser(id) {
    return request({
        url: `/web/back/sys/consume/${id}`,
        method: 'get',
    })
}